var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.333 51.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,21a7,7,0,1,1-7,7,7.021,7.021,0,0,1,7-7m0-4.667A11.667,11.667,0,1,0,39.667,28,11.671,11.671,0,0,0,28,16.333Zm-23.333,14H9.333a2.333,2.333,0,1,0,0-4.667H4.667a2.333,2.333,0,1,0,0,4.667Zm42,0h4.667a2.333,2.333,0,0,0,0-4.667H46.667a2.333,2.333,0,0,0,0,4.667Zm-21-25.667V9.333a2.333,2.333,0,1,0,4.667,0V4.667a2.333,2.333,0,1,0-4.667,0Zm0,42v4.667a2.333,2.333,0,0,0,4.667,0V46.667a2.333,2.333,0,0,0-4.667,0Zm-11.69-35.98a2.326,2.326,0,0,0-3.29,3.29L13.16,16.45a2.326,2.326,0,0,0,3.29-3.29ZM42.84,39.55a2.326,2.326,0,0,0-3.29,3.29l2.473,2.473a2.326,2.326,0,0,0,3.29-3.29Zm2.473-25.573a2.326,2.326,0,0,0-3.29-3.29L39.55,13.16a2.326,2.326,0,0,0,3.29,3.29ZM16.45,42.84a2.326,2.326,0,0,0-3.29-3.29l-2.473,2.473a2.326,2.326,0,0,0,3.29,3.29Z",
    transform: "translate(-2.333 -2.333)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSun);
export default __webpack_public_path__ + "static/media/ico_sun.b8f9d27549fbf7f17c199eef42d8822e.svg";
export { ForwardRef as ReactComponent };